export const comment = {
  id: "",
  user: "",
  timestamp: 0,
  text: ""
}
